(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4666],{

/***/ 86154:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frequently-asked-questions",
      function () {
        return __webpack_require__(19397);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31014);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46323);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66893);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28808);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52662);
/* harmony import */ var enums_country__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72473);

// @ts-ignore










var FAQ = function(param) {
    var priceMonthly = param.priceMonthly, priceYearly = param.priceYearly, priceYearlyDiscount = param.priceYearlyDiscount, countryCode = param.countryCode;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.FAQ */ .l.FAQ).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_7__/* .basicSEO */ .F)(t("seo:frequently_asked_questions_title"), t("seo:frequently_asked_questions_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().faq),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().faqWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_6__/* .FAQList */ .Vv, {
                            priceMonthly: priceMonthly,
                            priceYearly: priceYearly,
                            priceYearlyDiscount: priceYearlyDiscount,
                            countryCode: countryCode
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().more),
                            children: [
                                t("know_more"),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "mailto:support@dramox.tv",
                                    target: "_blank",
                                    children: function() {
                                        switch(countryCode){
                                            case enums_country__WEBPACK_IMPORTED_MODULE_9__/* .Country.Czechia */ .c.Czechia:
                                                return "napoveda@dramox.cz";
                                            case enums_country__WEBPACK_IMPORTED_MODULE_9__/* .Country.Slovakia */ .c.Slovakia:
                                                return "napoveda@dramox.cz";
                                            case enums_country__WEBPACK_IMPORTED_MODULE_9__/* .Country.Ukraine */ .c.Ukraine:
                                                return "pidtrymka@dramox.tv";
                                            default:
                                                return "support@dramox.tv";
                                        }
                                    }()
                                }),
                                "."
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_8__/* .withForcePlanToLoggedInUnsubs */ .DE)(FAQ));


/***/ }),

/***/ 31014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faq":"frequently-asked-questions_faq__5oIIi","more":"frequently-asked-questions_more__S_HTS"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(86154); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);